<div class="action-container my-styles">
  <div
    ngbDropdown
    class="dropdown d-inline-flex"
    container="body"
    [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
    *appHasRole="['Admin']"
  >
    <app-ag-action-icon-button
      ngbDropdownToggle
      iconClass="ic-more-horizontal-16"
      [disabled]="disabled"
    />

    <div ngbDropdownMenu class="common-dropdown-menu dropdown-menu dropdown-menu-right">
      @if (showDelete) {
        @if (showResend) {
          <div ngbDropdownItem class="dropdown-item" (click)="resend()">
            <span>Resend</span>
          </div>
        }

        <div ngbDropdownItem class="dropdown-item" (click)="delete()">
          <span>Delete</span>
        </div>
      } @else {
        <div class="no-action">No Action</div>
      }
    </div>
  </div>
</div>
